<template>
  <div class="impot-societes-create page-layout">
    <PageHeader
      :has-back="true"
      @back="goBack"
      title="Créer un impôt societe"
    />

    <md-card class="meep-form">
      <md-card-content>
        <div class="meep-input">
          <div class="meep-form-column meep-form-single-column">
            <md-field :class="{ 'md-invalid': errors.has('montant_min') }">
              <label>Montant min *</label>
              <md-input
                v-model="form.montant_min"
                v-validate="'required|decimal'"
                name="montant_min"
                type="text"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('montant_min')">
                {{ errors.first("montant_min") }}
              </span>
            </md-field>
          </div>

          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('montant_max') }">
              <label>Montant max *</label>
              <md-input
                v-model="form.montant_max"
                v-validate="'required|decimal'"
                name="montant_max"
                type="text"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('montant_max')">
                {{ errors.first("montant_max") }}
              </span>
            </md-field>
          </div>

          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('coef_bas') }">
              <label>Coef bas*</label>
              <md-input
                v-model="form.coef_bas"
                v-validate="'required|decimal'"
                name="coef_bas"
                type="text"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('coef_bas')">
                {{ errors.first("coef_bas") }}
              </span>
            </md-field>
          </div>

          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('coef_haut') }">
              <label>Coef haut*</label>
              <md-input
                v-model="form.coef_haut"
                v-validate="'required|decimal'"
                name="coef"
                type="text"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('coef_haut')">
                {{ errors.first("coef_haut") }}
              </span>
            </md-field>
          </div>

          <div class="md-layout md-alignment-center-right">
            <md-button
              class="md-raised md-primary"
              @click.native="createImpotDeSocietes"
            >
              Créer un impôt de societe
              <md-icon>
                add
              </md-icon>
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import calculatorsModel from "../../../../model/calculators";
import PageHeader from "@/components/PageHeader";

export default {
  components: { PageHeader },
  data() {
    return {
      isDebug: false,
      form: {
        montant_min: "",
        montant_max: "",
        coef_bas: "",
        coef_haut: "",
      },
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
    createImpotDeSocietes() {
      this.$validator.validateAll().then(result => {
        if (result) {
          calculatorsModel
            .createSocietes(this.form)
            .then(() => {
              this.$toasted.global.AppSucces({
                message: "L'impot de societe a bien été enregistré",
              });

              this.$router.push("/admin/calculators/impot-societes/list");
            })
            .catch(err => {
              this.$toasted.global.AppError({
                message: err.msg,
              });
            });
        } else {
          this.$toasted.global.AppInfo({
            message: "Vous devez remplir les champs manquants",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.impot-societes-create {
  .debug-log {
    max-height: 360px;
    overflow-y: scroll;
  }

  .md-card {
    margin-top: 32px;
    margin-bottom: 32px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
